<template>
<div class="grid mt-4">	
<template v-if="!is_connected">
<div class="col-12 ">
<h4 class="text-red-500">Bu modüle bağlı bir veri modülü bulunmuyor</h4>
</div>	
</template>

<template v-else>

<div class="col-12 ">
<span class="p-float-label">
<InputText  type="text" v-model="name" class="w-full p-inputtext-sm"  @change="nameUpdated"  />
<label  class="text-primary">İsim</label>
</span>
</div>


<div class="col-12 ">
<h4 class="text-primary">Karşılaştırmalar</h4>
<hr>
</div>

<template v-if="$store.state.calculations.selectednode.data">

<div class="col-12">
<draggable 
v-model="$store.state.calculations.selectednode.data.logic_bundles"
class="logic_bundle_wrap" 
@change="change"
v-bind="dragOptions"
handle=".handle"
item-key="id">

<template #item="{element,index}" >

<Panel  
toggleable
:collapsed="element.collapsed"
@update:collapsed="updateCollapsed($event,index)"
>
<template #header>
<i class="pi pi-sort-alt handle mr-2"></i>
<div 
v-tooltip.left="getBundleTitle(element.id,index)"
class="white-space-nowrap overflow-hidden text-overflow-ellipsis" style="width:70%">
 {{getBundleTitle(element.id,index)}}
</div>
</template>
<template #icons>  
  <Button  icon="pi pi-trash" @click="deleteBundle($event,element.id)"   class=" p-button-danger p-button-text  mr-2 py-0" style="height:26px" />
</template>

<div class="grid">
<LogicBundle
:bundle="element"
:inputs="inputs"
/>
</div>

</Panel>
</template>
</draggable>





</div>



</template>

<div class="col-12">
<Button label="Yeni Ekle"  class="p-button-outlined p-button-sm p-button-primary"   @click="addLogicBundle"></Button>
</div>



	
</template>
<ConfirmPopup group="deletebundle"></ConfirmPopup>
</div>
</template>

<script>
const conditionmodel = {
    		id:null,
        type:null,//inputfield,customattribute
        comparison_type:null,
        selected_input:null,
        comparison_input:null,
        text_val:null,
        numerical_val:null,
        execution_type:null,
        operator:null,
    	}
const logic_bundle_model = {
  id:null,
  conditions:[],
  outcome:null,
  collapsed:false
}
import LogicBundle from "./LogicBundle"


export default {

  name: 'ConditionalLogicNode',

  data () {
    return {
      conditions:[],
    	inputs:[],
    	name:null,
    }
  },
  components:{LogicBundle},
  computed:{
  	is_connected()
  	{
  		if(this.$store.state.calculations.selectednode)
  		{
  			let selectednode = this.$store.state.calculations.selectednode
        if(selectednode.data && selectednode.data.name)
        {
          this.name = selectednode.data.name
        }
  			
  			let connections = this.$store.state.calculations.connections
  			let the_connection = connections.findIndex((item)=>{return item.to == selectednode.id})
  			if(the_connection!==-1)
  			{
  				let root_node = this.findRootNode()
  				return true
  			}
  			return false
  		}
  		return false  		
  	},
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods:{
    change()
    {

    },
    getBundleTitle(id,index)
    {
      let selectednode = this.$store.state.calculations.selectednode
      let bundle = selectednode.data.logic_bundles.find(item=>item.id == id)
      let first_condition = bundle.conditions[0]
      if(first_condition.selected_input)
      {
        return first_condition.selected_input.name
      }
      else
      {
        return "karşılaştırma "+(index+1)
      }
    },
    deleteBundle(event,id)
    {
      this.$confirm.require({
          target: event.currentTarget,
          group: 'deletebundle',
          message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
          header: this.$store.state.languages.lang_phrases.silme_uyarisi,
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger p-button-outlined',
          acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
          rejectLabel:this.$store.state.languages.lang_phrases.iptal,
          accept: () => {
              this.submitDeleteBundle(id)
          },
          reject: () => {              
          }
      });
      
    },
    submitDeleteBundle(id)
    {
      let selectednode = this.$store.state.calculations.selectednode
      selectednode.data.logic_bundles = selectednode.data.logic_bundles.filter(item=>item.id !==id)
      this.updateNodeData(selectednode)
    },
    updateCollapsed(data,index)
    {
      
      let selectednode = this.$store.state.calculations.selectednode
      selectednode.data.logic_bundles[index].collapsed = data
      this.updateNodeData(selectednode)
    },
    conditionUpdated(data)
    {
      console.log("conditionUpdated")
      console.log(data)
      if(data.condition.operator=="execute")
      {

      }
      if(data.condition.operator=="and" || data.condition.operator=="or")
      {
        let selectednode = this.$store.state.calculations.selectednode
        let last_condition = selectednode.data.conditions[selectednode.data.conditions.length-1]
        if(!last_condition.id || !last_condition.comparison_type || !last_condition.execution_type || !last_condition.operator)
        {

        }
        else
        {
          this.addCondition()
        }
        
      }
    },
  	nameUpdated()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
      console.log("nameUpdated")
      console.log(selectednode)
  		selectednode.data.name = this.name
      selectednode.title = this.name
  		this.updateNodeData(selectednode)
  	},
  	removeCondition(id)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.conditions = selectednode.data.conditions.filter((item)=>{return item.id !== id})
  		this.updateNodeData(selectednode)
  	},
    addLogicBundle()
    {
      let selectednode = this.$store.state.calculations.selectednode
      let logic_bundle = this.sanitizeArray(logic_bundle_model)
      logic_bundle.id = this.generateId()
      let condition = this.sanitizeArray(conditionmodel)
      condition.id = this.generateId()
      logic_bundle.conditions.push(condition)
      selectednode.data.logic_bundles.push(logic_bundle)
      this.updateNodeData(selectednode)
    },
  	addCondition()
  	{  		
  		let selectednode = this.$store.state.calculations.selectednode
  		let condition = this.sanitizeArray(conditionmodel)
  		condition.id = this.generateId()
  		selectednode.data.conditions.push(condition)
  		this.updateNodeData(selectednode)
  	},
  	inputSelected()
  	{
  		console.log(this.selected_input)
  		console.log(this.$store.state.calculations.nodes)
  	},
  	updateNodeData(selectednode)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
  		nodes[ind] = selectednode
  		this.$store.dispatch('calculations/setNodes',nodes)
      	this.$store.dispatch('calculations/setSelectedNode',selectednode)
  	},
  	findRootNode()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let the_connection = connections.find((item)=>{return item.to == selectednode.id.toString()}) 
  		if(the_connection)
  		{  			
  			let from_node = this.findPrevNode(the_connection.from) 
        console.log("from_node")  
        console.log(from_node)  		
  			return from_node
  		}
  		return "no_connection"
  	},
  	findPrevNode(nodeId)
  	{
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let node = nodes.find((item)=>{return item.id == nodeId.toString()})
  		if(node.key=="calculations")
  		{  				
  			let calculation_item = {
            stack_id:node.id,
            name:node.title,
            type:"calculation",
          }
          this.addToInputsStack(calculation_item)
  		}
      if(node.type=="conditional_logic")
      {         
        let calculation_item = {
              stack_id:node.id,
              name:node.title,
              type:"conditional_logic",
          }
          this.addToInputsStack(calculation_item)
      }
  		//if prev node is not suppliers
  		if(node.type!=="suppliers")
  		{
  			let the_connection = connections.find((item)=>{return item.to == nodeId.toString()})
  			if(!the_connection)
  			{
  				return "no_connection"
  			}
  			let from_node = this.findPrevNode(the_connection.from)  			
  			return from_node
  		}
  		//if prev node is not suppliers

  		//if prev node is suppliers
      if(node.type=="suppliers")
      {
        node = this.sanitizeArray(node)
        let outputs = node.data.outputs
        console.log("OUTPUTS")
        let filtered = outputs.filter((item)=>{
            if(item.name.length>120)
            {
              item.name = item.name.substring(0, 120)+"..."
            }
            if(item.type=="project_status")
            {
              item.name = item.name
              return item
            }
            if(item.type=="flow_status")
            {
              item.name = item.name
              return item
            }
            if(item.type=="section_points")
            {
              item.name = item.name+" - Aşama Bölüm Puanı"
              return item
            }
            if(item.type=="section_nonconformities")
            {
              item.name = item.name+" - Bölüm Uygunsuzluk Sayısı"
              return item
            }
            if(item.type=="questionlist_points")
            {
              item.name = item.name+" - Aşama Puanı"
              return item
            }
            if(item.type=="questionlist_custom_points")
            {
              item.name = item.name+" - Aşama Özel Puanı"
              return item
            }
            if(item.type=="inputfield_point")
            {
              item.name = item.name+" - Soru Puanı"
              return item
            }
            if(item.type=="verification_auditor")
            {
              item.name = item.name+" - Doğrulama Denetçisi"
              return item
            }
            if(item.type=="audit_auditor")
            {
              item.name = item.name+" - Denetleme Denetçisi"
              return item
            }
            if(item.type=="inputfield_nonconformity_count")
            {
              item.name = item.name+" - Soru Uygunsuzluk Durumu"
              return item
            }
            if(item.type=="questionlist_nonconformity_count")
            {
              item.name = item.name+" - Aşama Uygunsuzluk Sayısı"
              return item
            }
            if(item.type=="custom_attribute")
            {
              item.name = item.name+" - Özel Nitelik"
              return item
            }
            if(item.type=="inputfield_null_reason")
            {
              item.name = item.name+" - Soru Boş Bırakma Nedeni"
              return item
            }
            if(item.type=="inputfield_submission")
            {
              item.name = item.name+" - Soru Verisi"
              return item
            }
            if(item.type=="supplier_location")
            {
              item.name = item.name+" - Tedarikçi Adres"
              return item
            }
            if(item.type=="supplier_users")
            {
              item.name = item.name+" - Tedarikçi Kullanıcıları"
              return item
            }
            if(item.type=="last_supplier_conversation")
            {
              item.name = item.name+" - Son Tedarikçi Görüşmesi"
              return item
            }

          })

        for(let item of filtered)
        {
          this.addToInputsStack(item)
        }
        return node

      }
      //if prev node is suppliers
  		
  		
  		//if prev node is suppliers

  	},
  	addToInputsStack(input)
  	{
  		
  		this.inputs.push(input)
  	},

  },
}
</script>

<style lang="css">
  .handle{
    cursor: pointer;
  }
  .logic_bundle_wrap>.p-panel>.p-toggleable-content>.p-panel-header{
    justify-content: flex-start;
  }
  .logic_bundle_wrap>.p-panel>.p-toggleable-content>.p-panel-content{
    padding: 7px;
    padding-top: 1rem;
  }
</style>